import { FormLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { Box } from "@mui/material";

const SingleSelectionDropdown = ({ title, value, dropdownData, handleValueChange, keys, style, sx, viewSx, showLegend = false }) => {
  return (
    <Box style={{ display: 'inline-block', ...style }}>
      {title && <FormLabel component="legend">{title}</FormLabel>}
      <Select sx={viewSx ? viewSx : {}} style={{ marginTop: '5px', maxWidth: 'calc(100vw - 30px)', }}
        id={value}
        value={value || ""}
        onChange={handleValueChange}
        variant="outlined"
        fullWidth
      >
        {dropdownData &&
          dropdownData.map((option) => (
            <MenuItem sx={sx ? sx : {}} key={option[keys.id]} value={option[keys.value]}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {showLegend && option[keys.color]? (
                  <Box
                    sx={{
                      width: {
                        xs: '11px',
                        sm: '13px',
                      },
                      height: {
                        xs: '11px',
                        sm: '13px',
                      },
                      backgroundColor: option[keys.color],
                      marginRight: 5,
                    }}
                  />
                ) : null}
                {option[keys.text]}
              </Box>
            </MenuItem>
          ))}
      </Select>
    </Box>
  );
};

export default SingleSelectionDropdown;
